module.exports = __webpack_public_path__ + "static/img/home_6.01d574d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home_6.png
// module id = KVY5
// module chunks = 1